import React from 'react';
import VariableInserter from '../TemplateEditor/VariableInserter';
import ColorPicker from '../ui/ColorPicker';

const HeroBlockEditor = ({ block, onUpdate }) => {
  const headlineInputRef = React.useRef(null);
  const subheadlineInputRef = React.useRef(null);

  const handleChange = (field, value) => {
    onUpdate(block.id, {
      config: {
        ...block.config,
        [field]: value,
      },
    });
  };

  const handleStyleChange = (field, value) => {
    onUpdate(block.id, {
      styles: {
        ...block.styles,
        [field]: value,
      },
    });
  };

  const handleInsertVariable = (field, variable) => {
    const currentValue = block.config[field] || '';
    handleChange(field, currentValue + variable);
  };

  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Hero Content</h4>

        <div className="editor-field">
          <label>Image URL</label>
          <input
            type="url"
            value={block.config.imageUrl || ''}
            onChange={(e) => handleChange('imageUrl', e.target.value)}
            placeholder="https://example.com/hero.jpg"
          />
        </div>

        <div className="editor-field">
          <label>Headline</label>
          <input
            ref={headlineInputRef}
            type="text"
            value={block.config.headline || ''}
            onChange={(e) => handleChange('headline', e.target.value)}
            placeholder="Your Headline Here"
          />
          <VariableInserter
            onInsert={(variable) => handleInsertVariable('headline', variable)}
            targetField="headline"
          />
        </div>

        <div className="editor-field">
          <label>Subheadline</label>
          <input
            ref={subheadlineInputRef}
            type="text"
            value={block.config.subheadline || ''}
            onChange={(e) => handleChange('subheadline', e.target.value)}
            placeholder="Your subheadline text"
          />
          <VariableInserter
            onInsert={(variable) => handleInsertVariable('subheadline', variable)}
            targetField="subheadline"
          />
        </div>

        <div className="editor-field">
          <label>Text Alignment</label>
          <select
            value={block.config.textAlign || 'center'}
            onChange={(e) => handleChange('textAlign', e.target.value)}
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>
      </div>

      <div className="editor-section">
        <h4 className="editor-section-title">Styling</h4>

        <div className="editor-field">
          <ColorPicker
            label="Background Color"
            color={block.styles.backgroundColor || '#1a1a1a'}
            onChange={(value) => handleStyleChange('backgroundColor', value)}
          />
        </div>

        <div className="editor-field">
          <label>Padding (px)</label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
            <input
              type="number"
              value={block.styles.padding?.top || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, top: parseInt(e.target.value) })}
              placeholder="Top"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.right || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, right: parseInt(e.target.value) })}
              placeholder="Right"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.bottom || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, bottom: parseInt(e.target.value) })}
              placeholder="Bottom"
              min="0"
            />
            <input
              type="number"
              value={block.styles.padding?.left || 20}
              onChange={(e) => handleStyleChange('padding', { ...block.styles.padding, left: parseInt(e.target.value) })}
              placeholder="Left"
              min="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBlockEditor;
